import React, { useState } from "react";
import CurriculumHeader from "components/header/CurriculumHeader";
import useLessons from "hooks/lessons/useLessons";
import LessonsList from "components/lessons/LessonsList";
import LessonsFilters from "components/lessons/LessonsFilters";

const Lessons = () => {
  const [filters, setFilters] = useState({});
  const { lessons, isLoading, getNextPage, page, setPage, hasMoreItems } =
    useLessons(filters);
  return (
    <div className="flex flex-col justify-center gap-4 xl:gap-10 xl:mx-24 mt-10">
      <CurriculumHeader
        title="ԱԶԳԱՅԻՆ ԿՐԹԱԿԱՐԳԻ"
        sectionTitle="Դասեր"
        buttonTitle="Դասընթացներ"
        buttonLink="/courses"
      />
      <div className="bg-white rounded-[24px]">
        <LessonsFilters filters={filters} setFilters={setFilters} />
        <LessonsList
          lessons={lessons}
          isLoadingNextPage={isLoading}
          hasMoreItems={hasMoreItems}
          getNextPage={getNextPage}
          page={page}
          setPage={setPage}
        />
      </div>
    </div>
  );
};

export default Lessons;
